import { WebStorageStateStore } from "oidc-client-ts";
import { ReactNode, useCallback } from "react";
import { AuthProvider as AuthProviderOIDC, AuthProviderProps } from "react-oidc-context";
import { useLocation, useNavigate } from "react-router-dom";

import configParams from "../env";

export function AuthProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();

  const oidcConfig: AuthProviderProps = {
    authority: `${configParams.AUTH_BASE}/realms/blox`,
    client_id: configParams.CLIENT_ID,
    redirect_uri: window.location.origin,
    onSigninCallback: useCallback(() => {
      const replaceUrl = new URL(window.location.toString());
      replaceUrl.searchParams.delete("code");
      replaceUrl.searchParams.delete("error");
      replaceUrl.searchParams.delete("session_state");
      replaceUrl.searchParams.delete("state");
      replaceUrl.searchParams.delete("iss");

      navigate(
        {
          ...location,
          search: replaceUrl.searchParams.toString(),
        },
        { replace: true }
      );
    }, [location, navigate]),
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };

  return <AuthProviderOIDC {...oidcConfig}>{children}</AuthProviderOIDC>;
}
